import { type ApolloError, gql, useQuery } from '@apollo/client';
import type { PersonBase } from '@domain/person';

const query = gql`
  query searchPeople($name: String, $idnumber: String, $darn: Int) {
    personSearch(name: $name, idnumber: $idnumber, darn: $darn) {
      idnumber
      darn
      firstname
      surname
      position
      flags
    }
  }
`;

interface PersonSearchResult {
  personSearch: PersonBase[];
}

interface PersonSearchVars {
  name?: string;
  idnumber?: string;
  darn?: number;
}

interface PersonSearchReturns {
  loading: boolean;
  error?: ApolloError;
  people?: PersonBase[];
}

export default function usePersonSearch(
  args: PersonSearchVars,
  skip: boolean = false
): PersonSearchReturns {
  const { error, loading, data } = useQuery<
    PersonSearchResult,
    PersonSearchVars
  >(query, { variables: args, skip, fetchPolicy: 'no-cache' });
  if (error != null) throw error;
  return {
    loading,
    error,
    people: data?.personSearch,
  };
}
